/* eslint-disable */
import React from 'react';
import { ImageSelect } from '../_shared/ImageSelect';

const OPTIONS = [{ id: 'blonde' }, { id: 'brown' }, { id: 'black' }, { id: 'red' }, { id: 'gray' }, { id: 'auburn' }];

function Page() {
  return (
    <ImageSelect
      page="hairstyle-hair-color"
      progress={41}
      field="hairstyleHairColor"
      setter="setHairstyleHairColor"
      ns="hairstyleHairColor"
      options={OPTIONS}
    />
  );
}

export default Page;
